import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useOutletContext } from 'react-router-dom';
import SensorsComponent from '../../../components/Fireboard/components/Sensors/index';
import { setErrorPopUp, setNotification } from '../../../reducers/notification';
import {
  getSensorsGroupList,
  deRegisterSensor,
  registerSensor,
  getNamedSensors,
  assignSensorGroup,
} from '../../../reducers/fireboard/sensors';
import { getObjectValue } from '@utility/utills';
import {
  getPopupConfig,
  PopupContent,
} from '../../../components/common/Popup/index';
import constant from '@components/common/globalization';
import Popup from '@components/common/Popup/Popup';
import RegisterSensor from '../../../components/Fireboard/components/Sensors/TableSensors/RegisterSensor';
import Addsensor from '../../../components/Fireboard/components/Sensors/AddSensor';
import { getLastCodeFromQrCode } from '@utility/fireboardUtil';
import RegisterNamedSensor from '../../../components/Fireboard/components/Sensors/NamedSensor/RagisterNamedSensor';
import SensorGroupEdit from '../../../components/Fireboard/components/Sensors/SensorGroupEdit';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const Sensors = props => {
  const { getPopup, popup, setPopup } = useOutletContext();
  const [selectedSensorTab, setSelectedSensorTab] = useState('table');
  const [sensorsMap, setSensorsMap] = useState(new Map());
  const [selectedStation, setSelectedStation] = useState(null);
  const [stationsWithSensors, setStationsWithSensors] = useState([]);
  const [stationsWithoutSensors, setStationsWithoutSensors] = useState([]);
  const [fieldValue, setFieldValue] = useState('');
  const [group, setGroup] = useState();
  const [codeValue, setCodeValue] = useState([]);
  const [showQRSection, setShowQRSection] = useState(false);
  const [namedSensors, setNamedSensors] = useState([]);
  const [namedFieldValue, setNamedFieldValue] = useState('');
  const [selectedSensor, setSelectedSensor] = useState();
  const [isDuplicate, setIsDuplicate] = useState(false);

  const storeInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem('auth'), false)
  );
  const sensorGroupsList = storeInfo?.sensorGroups;

  useEffect(() => {
    if (selectedSensorTab === 'table') {
      getTableSensorList();
    } else {
      getNamedSensorList();
    }
  }, [selectedSensorTab]);

  useEffect(() => {
    // calling filterStations after getSensorList
    if (sensorsMap && sensorsMap.size > 0) {
      filterStations();
    }
  }, [sensorsMap]);

  const getTableSensorList = () => {
    getPopup('spinner');
    props
      .getSensorsGroupList(storeInfo?.id)
      .then(response => {
        const sensorsData = response;
        let sensorsMap1 = new Map();

        sensorsData.forEach(sensor => {
          if (sensor.stationId) {
            if (sensorsMap1.has(sensor.stationId)) {
              const existingSensors = sensorsMap1.get(sensor.stationId);
              sensorsMap1.set(sensor.stationId, [...existingSensors, sensor]);
            } else {
              sensorsMap1.set(sensor.stationId, [sensor]);
            }
          }
        });

        setSensorsMap(sensorsMap1);
        setPopup(null);
      })
      .catch(error =>
        props.setErrorPopUp({
          res: error.message,
        })
      );
  };

  const getNamedSensorList = () => {
    getPopup('spinner');
    props
      .getNamedSensors(storeInfo?.id)
      .then(res => {
        setNamedSensors(res);
        setPopup(null);
      })
      .catch(error =>
        props.setErrorPopUp({
          res: error.message,
        })
      );
  };
  const normalize = value =>
    String(value)
      .trim()
      .replace(/\s+/g, ''); // remove all spaces

  const checkDuplicate = scanCode => {
    const duplicateFound = [
      ...Array.from(sensorsMap.values()).flat(),
      ...(namedSensors || []),
    ].some(sensor => normalize(sensor.externalId) === normalize(scanCode));

    setIsDuplicate(duplicateFound);

    return duplicateFound;
  };

  const onRegisterSensor = qrCode => {
    getPopup('spinner');

    const basePayload = {
      storeId: storeInfo?.id,
      externalId: getLastCodeFromQrCode(qrCode),
      sensorGroupId: group?.id || null,
    };

    const payload =
      selectedSensorTab === 'table'
        ? {
            ...basePayload,
            sensorTypeId: 1,
            stationId: selectedStation?.id,
          }
        : {
            ...basePayload,
            sensorTypeId: 6,
            stationId: null,
            name: namedFieldValue?.trim(),
          };

    props
      .registerSensor(payload)
      .then(res => {
        if (selectedSensorTab === 'table') {
          setSensorsMap(prevMap => {
            const newMap = new Map(prevMap);
            const existingSensors = newMap.get(res.stationId) || [];
            newMap.set(res.stationId, [...existingSensors, res]);
            return newMap;
          });
        } else {
          setNamedSensors(prevSensors => [...prevSensors, res]);
        }
        setPopup(null);
        setGroup(null);
        setNamedFieldValue(null);
        props.setNotification({
          type: 'success',
          message: FLABEL().TOAST_ADD_SENSOR,
        });
      })
      .catch(error => {
        setPopup(null);
        props.setErrorPopUp({
          res: error?.message || FLABEL().TABLE_SENSOR_FAILED_MESSAGE,
        });
      });
  };

  const filterStations = () => {
    const { stations } = storeInfo || {};
    const stationsArray = Array.isArray(stations) ? stations : [];

    const withSensors = stationsArray.filter(station =>
      withStationFilterFn(station)
    );
    const withoutSensors = stationsArray.filter(station =>
      withoutStationFilterFn(station)
    );

    setStationsWithSensors(withSensors);
    setStationsWithoutSensors(withoutSensors);
  };

  const withStationFilterFn = station => {
    if (sensorsMap.has(station.id)) {
      const sens = sensorsMap.get(station.id);
      return Array.isArray(sens) && sens.length > 0;
    }
    return false;
  };

  const withoutStationFilterFn = station => {
    if (sensorsMap.has(station.id)) {
      const sens = sensorsMap.get(station.id);
      return Array.isArray(sens) && sens.length === 0;
    }
    return true;
  };

  const searchTerm = fieldValue.toLowerCase();

  const filteredWithSensors = stationsWithSensors.filter(station => {
    return (
      station.name?.toLowerCase().includes(searchTerm) ||
      String(station.number || station.id).includes(searchTerm)
    );
  });

  const filteredWithoutSensors = stationsWithoutSensors.filter(station => {
    return (
      station.name?.toLowerCase().includes(searchTerm) ||
      String(station.number || station.id).includes(searchTerm)
    );
  });

  const onClickDeleteSensor = sensor => {
    const callback = () => {
      getPopup('spinner');
      props
        .deRegisterSensor(sensor.id)
        .then(res => {
          if (selectedSensorTab === 'table') {
            const existingSensors = sensorsMap.get(sensor.stationId);
            const newSensors = existingSensors.filter(s => s.id !== sensor.id);
            sensorsMap.set(sensor.stationId, [...newSensors]);
            setSensorsMap(sensorsMap);
          } else {
            setNamedSensors(namedSensors.filter(s => s.id !== sensor.id));
          }
          setPopup(null);
          setFieldValue('');
          props.setNotification({
            type: 'success',
            message: FLABEL().TOAST_DELETE_SENSOR,
          });
        })
        .catch(error =>
          props.setErrorPopUp({
            res: error.message,
          })
        );
    };

    const station = stationsWithSensors.find(st => st.id === sensor.stationId);
    const stationName = station?.name || station?.number;

    const popup = getPopupConfig('success');
    popup.heading = FLABEL().TABLE_SENSOR_DELETE_SENSOR;
    popup.message =
      selectedSensorTab === 'table'
        ? FLABEL().TABLE_SENSOR_DELETE_SENSOR_MESSAGE.replace(
            '{{stationName}}',
            stationName
          )
        : FLABEL().NAMED_DELETE_SENSOR;
    popup.buttons = [
      {
        btnType: 'cancel',
        text: FLABEL().TABLE_SENSOR_NO,
        onClick: () => {
          setPopup(null);
        },
      },
      {
        btnType: 'submit',
        text: FLABEL().TABLE_SENSOR_YES,
        onClick: () => {
          callback && callback();
        },
      },
    ];
    setPopup(popup);
  };

  const handleAssignSensorGroup = (sensorId, groupId) => {
    getPopup('spinner');
    props
      .assignSensorGroup(sensorId, groupId)
      .then(res => {
        setPopup(null);
        setGroup(null);
        if (selectedSensorTab === 'table') {
          setSensorsMap(prevMap => {
            const newMap = new Map(prevMap);
            for (let [stationId, sensors] of newMap.entries()) {
              const sensorIndex = sensors.findIndex(s => s.id === sensorId);
              if (sensorIndex !== -1) {
                const updatedSensors = [...sensors];
                updatedSensors[sensorIndex] = {
                  ...updatedSensors[sensorIndex],
                  sensorGroupId: groupId,
                };
                newMap.set(stationId, updatedSensors);
                break;
              }
            }
            return newMap;
          });
        } else {
          setNamedSensors(prev =>
            prev.map(sensor =>
              sensor.id === sensorId
                ? { ...sensor, sensorGroupId: groupId }
                : sensor
            )
          );
        }
        props.setNotification({
          type: 'success',
          message: FLABEL().TOAST_UPDATE_SENSOR,
        });
      })
      .catch(error =>
        props.setErrorPopUp({
          res: error.message,
        })
      );
  };

  const onClickEdit = sensor => {
    const sensorGrp = sensorGroupsList.find(
      item => item.id === sensor?.sensorGroupId
    );
    setSelectedSensor(sensor);
    setGroup(sensorGrp);
    setPopup({ type: constant.ASSIGN_SENSOR_GROUP });
  };

  const onClickAddSensor = station => {
    setSelectedStation(station);
    if (Array.isArray(sensorGroupsList) && sensorGroupsList.length > 0) {
      setPopup({ type: constant.SENSOR_GROUP });
      setFieldValue('');
      setShowQRSection(false);
      setGroup(sensorGroupsList[0]);
    } else if (window.ReactNativeWebView) {
      EventEmitter.scanQRCode('scanQRCode');
    }
  };

  const OnChangeTab = key => {
    setSelectedSensorTab(key);
    setFieldValue('');
    setPopup(null);
    setShowQRSection(false);
  };

  const getPopupContent = () => {
    if (!popup) return null;
    switch (popup.type) {
      case constant.SENSOR_GROUP:
        if (selectedSensorTab === 'named') {
          return (
            <RegisterNamedSensor
              setPopup={setPopup}
              sensorGroupsList={sensorGroupsList}
              selectedStation={selectedStation}
              setGroup={setGroup}
              group={group}
              setCodeValue={setCodeValue}
              setShowQRSection={setShowQRSection}
              showQRSection={showQRSection}
              selectedSensorTab={selectedSensorTab}
              namedFieldValue={namedFieldValue}
              setNamedFieldValue={setNamedFieldValue}
              checkDuplicate={checkDuplicate}
            />
          );
        }
        return (
          <RegisterSensor
            setPopup={setPopup}
            sensorGroupsList={sensorGroupsList}
            selectedStation={selectedStation}
            setGroup={setGroup}
            group={group}
            setCodeValue={setCodeValue}
            setShowQRSection={setShowQRSection}
            showQRSection={showQRSection}
            selectedSensorTab={selectedSensorTab}
            namedFieldValue={namedFieldValue}
            setNamedFieldValue={setNamedFieldValue}
            fieldValue={fieldValue}
            checkDuplicate={checkDuplicate}
          />
        );

      case constant.ADD_SENSOR:
        return (
          <Addsensor
            setPopup={setPopup}
            selectedStation={selectedStation}
            group={group}
            codeValue={codeValue}
            namedFieldValue={namedFieldValue}
            onRegisterSensor={onRegisterSensor}
            isDuplicate={isDuplicate}
          />
        );
      case constant.ASSIGN_SENSOR_GROUP:
        return (
          <SensorGroupEdit
            sensorGroupsList={sensorGroupsList}
            setPopup={setPopup}
            selectedSensor={selectedSensor}
            group={group}
            setGroup={setGroup}
            handleAssignSensorGroup={handleAssignSensorGroup}
          />
        );

      default:
        return <PopupContent {...popup} />;
    }
  };

  const getPopupViewType = () => {
    if (!popup) return null;
    let isFullWidth = false;
    switch (popup.type) {
      case constant.SENSOR_GROUP:
        isFullWidth = true;
        break;
      case constant.ADD_SENSOR:
        isFullWidth = true;
        break;
      case constant.ASSIGN_SENSOR_GROUP:
        isFullWidth = true;
        break;
      default: {
        isFullWidth = false;
        break;
      }
    }
    return isFullWidth;
  };

  return (
    <div className="h-100">
      <SensorsComponent
        selectedSensorTab={selectedSensorTab}
        setSelectedSensorTab={setSelectedSensorTab}
        OnChangeTab={OnChangeTab}
        filteredWithSensors={filteredWithSensors}
        filteredWithoutSensors={filteredWithoutSensors}
        sensorGroupsList={sensorGroupsList}
        sensorsMap={sensorsMap}
        onClickDeleteSensor={onClickDeleteSensor}
        fieldValue={fieldValue}
        setFieldValue={setFieldValue}
        onClickAddSensor={onClickAddSensor}
        namedSensors={namedSensors}
        onClickEdit={onClickEdit}
        currentView={props.currentView}
      />

      <Popup visible={!!popup} fullPopupView={getPopupViewType()}>
        {getPopupContent()}
      </Popup>
    </div>
  );
};

const mapStateToProps = ({ oauth }) => ({
  currentView: oauth.currentView,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setErrorPopUp,
      setNotification,
      getSensorsGroupList,
      deRegisterSensor,
      registerSensor,
      getNamedSensors,
      assignSensorGroup,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(Sensors);
